export class UserCredential {
  userName = '';
  password = '';
}
